// Generated by GitHub Copilot
import { ApiError } from '#core/api/Api.ts'
import AccountApi from '#core/api/auth/AccountApi.ts'
import type Account from '#core/entities/auth/accounts/Account.ts'
import { takeSsoLinked } from '#core/auth/sso-sign-in.ts'
import { State } from '#core/state/State.ts'

const accountApi = new AccountApi()

/** Drives the linked-accounts section: the accounts the user signs in with, and removing one. */
export class LinkedAccountsState extends State<LinkedAccountsState> {
  accounts: Account[] | null = null
  loadFailed = false
  /** Set when the backend refused a removal because it would leave the user without a way to sign in. */
  lastAccountRefused = false
  /** Set when this page load follows connecting an SSO account. */
  linked = takeSsoLinked()

  constructor(key: string | undefined, storage: Storage | null) {
    super(key, storage)
    void this.load()
  }

  async load(): Promise<void> {
    this.reactTo.loadFailed = false
    try {
      this.reactTo.accounts = await accountApi.listAccounts()
    } catch {
      this.reactTo.loadFailed = true
    }
  }

  /** True while the user has a single account, which can never be removed. */
  get onlyAccount(): boolean {
    return (this.accounts?.length ?? 0) <= 1
  }

  /** Removes `account`; a refusal for the last account is explained in the section, any other failure rejects. */
  async remove(account: Account): Promise<void> {
    this.reactTo.lastAccountRefused = false
    try {
      await accountApi.removeAccount(account.id)
    } catch (e) {
      const status = e instanceof ApiError ? e.response?.status : undefined
      if (status === 409) this.reactTo.lastAccountRefused = true
      else if (status !== 404) throw e
    }
    await this.load()
  }
}
